import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import SigninForm from './SigninForm'
import { requireNotToBeSignedIn } from '../hoc/signinRequirement'
import {
  ERROR_WRONG_PASSWORD,
  EMAIL_NOT_FOUND,
  ERROR_UNKNOWN
} from '../services/signin/constants'
import { FormCard, Error } from '../helpers/form'
import { MaxWidthContainer } from '../helpers/layout'

class SigninPage extends Component {
  componentWillMount() {
    this.handlePropsChange(this.props)
  }
  componentWillUpdate(nextProps) {
    this.handlePropsChange(nextProps)
  }
  handlePropsChange({ history, redirectTo, resetRedirectTo }) {
    if (redirectTo) {
      resetRedirectTo()
      history.push(redirectTo)
    }
  }
  handleSubmit(values) {
    this.props.signin(values)
  }
  render() {
    const { error, pending } = this.props
    return (
      <MaxWidthContainer>
        <FormCard title="Sign in">
          <SigninForm
            pending={pending}
            onSubmit={values => this.handleSubmit(values)}
          />
          {error === ERROR_WRONG_PASSWORD ? (
            <Error>Wrong password.</Error>
          ) : error === EMAIL_NOT_FOUND ? (
            <Error>No account with this e-mail address.</Error>
          ) : error === ERROR_UNKNOWN ? (
            <Error>An unknown error occurred.</Error>
          ) : (
            ''
          )}
        </FormCard>
      </MaxWidthContainer>
    )
  }
}

export default requireNotToBeSignedIn(withRouter(SigninPage))



// WEBPACK FOOTER //
// ./src/components/SigninPage.js